import customAxios from './interceptors';

const getMediumData = (mediumNumber: number, tenantId: string) => {
  return customAxios.get(`${process.env.REACT_APP_API_URL}/mediumdata/${tenantId}/${mediumNumber}`);
}

export default getMediumData;
